import {message} from '@ui/i18n/message';
import {Trans} from '@ui/i18n/trans';

export const statusCategoryNames = {
  scheduled: message('Scheduled'),
  open: message('Open'),
  pending: message('Pending'),
  closed: message('Closed'),
  locked: message('Locked'),
};

export const statusCategory = {
  // a ticket queued for future delivery (see Conversation::STATUS_SCHEDULED)
  scheduled: 7,
  open: 6,
  pending: 5,
  closed: 4,
  locked: 3,
};

export function StatusCategoryName({category}: {category: number}) {
  switch (category) {
    case statusCategory.scheduled:
      return <Trans {...statusCategoryNames.scheduled} />;
    case statusCategory.open:
      return <Trans {...statusCategoryNames.open} />;
    case statusCategory.pending:
      return <Trans {...statusCategoryNames.pending} />;
    case statusCategory.closed:
      return <Trans {...statusCategoryNames.closed} />;
    case statusCategory.locked:
      return <Trans {...statusCategoryNames.locked} />;
    default:
      return '-';
  }
}
